export const PHONE_MASK = "+__ ___ ___ ___";
export const PESEL_MASK = "___________";
export const OC_MASK = "_______";
export const ZIPCODE_MASK = "__-___";
